import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import translationSv from './translation-sv.json'
import translationEn from './translation-en.json'

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: false,
    resources: {
      en: { translation: translationEn },
      sv: { translation: translationSv },
    },
    detection: {
      order: ['htmlTag'],
    },
  })
